import './contentitem.css'

const ContentItem = ({ content }) => {
  const { title, description, image } = content

  return (
    <div class="content-item">
      <div class="content-item__image">
        {image && <img src={image} alt={title} />}
      </div>
      <div class="content-item__text">
        {title && <h5>{title}</h5>}
        {description && <p>{description}</p>}
      </div>
    </div>
  )
}

export default ContentItem